/** LIFF 内から外部ブラウザ / 地図アプリへ出すための関数 (MessengerPlatform.openExternalUrl)。 */
export type OpenExternalUrl = (url: string) => void;

const GOOGLE_MAPS_SEARCH = "https://www.google.com/maps/search/?api=1&query=";

/** normalize.ts が住所欠落時に埋めるプレースホルダ (そのまま検索させない) */
const ADDRESS_PLACEHOLDER = "—";

function isValidCoordinate(
  lat: number | null | undefined,
  lng: number | null | undefined,
): boolean {
  if (typeof lat !== "number" || typeof lng !== "number") return false;
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return false;
  return Math.abs(lat) <= 90 && Math.abs(lng) <= 180;
}

/**
 * 納品先 / 集荷先を開く Google マップの URL を組み立てる。
 * ジオコーディング済みの座標があれば座標優先 (ピンが正確)、無ければ住所文字列で検索する。
 * どちらも無い stop では null を返し、呼び出し側は導線自体を出さない。
 */
export function buildGoogleMapsUrl({
  lat,
  lng,
  address,
}: {
  lat?: number | null;
  lng?: number | null;
  address?: string | null;
}): string | null {
  if (isValidCoordinate(lat, lng)) return `${GOOGLE_MAPS_SEARCH}${lat},${lng}`;
  const trimmed = address?.trim() ?? "";
  if (trimmed === "" || trimmed === ADDRESS_PLACEHOLDER) return null;
  return `${GOOGLE_MAPS_SEARCH}${encodeURIComponent(trimmed)}`;
}
